/**
 * Habilleur size guide modal — open/close, unit toggle, measure tabs.
 * Plaatst de maattabel-trigger rechts naast de maatkeuze.
 */
function placeSizeGuideBesideSizes(root) {
  if (!(root instanceof HTMLElement)) return;
  if (root.dataset.placedBesideSizes === 'true') return;

  const detailsRoot =
    root.closest('.product-details') ||
    root.closest('.product-information') ||
    document;

  const fieldsets = detailsRoot.querySelectorAll('variant-picker fieldset.variant-option');
  let sizeFieldset = null;

  fieldsets.forEach((fieldset) => {
    if (sizeFieldset) return;
    const legend = fieldset.querySelector('legend');
    const name = (legend?.textContent || '').toLowerCase();
    const isSwatch = fieldset.classList.contains('variant-option--swatches');
    if (isSwatch) return;
    if (
      name.includes('maat') ||
      name.includes('size') ||
      name.trim() === 'eu' ||
      name.includes('schoenmaat')
    ) {
      sizeFieldset = fieldset;
    }
  });

  // Fallback: eerste niet-swatch button fieldset
  if (!sizeFieldset) {
    sizeFieldset = detailsRoot.querySelector(
      'variant-picker fieldset.variant-option--buttons:not(.variant-option--swatches)'
    );
  }

  if (!(sizeFieldset instanceof HTMLElement)) return;

  sizeFieldset.classList.add('variant-option--with-size-guide');
  sizeFieldset.appendChild(root);
  root.dataset.placedBesideSizes = 'true';
  root.classList.add('habilleur-size-guide--inline');
}

function initSizeGuides() {
  document.querySelectorAll('.habilleur-size-guide').forEach((root) => {
    placeSizeGuideBesideSizes(root);

    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const dialog = root.querySelector('.habilleur-size-guide__dialog');
    const openBtn = root.querySelector('[data-size-guide-open]');
    const closeBtn = root.querySelector('[data-size-guide-close]');

    openBtn?.addEventListener('click', () => {
      dialog?.showModal();
    });

    closeBtn?.addEventListener('click', () => dialog?.close());

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') dialog.close();
    });

    root.querySelectorAll('[data-size-guide-units] button[data-unit]').forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.unit;
        if (!unit) return;

        root.querySelectorAll('[data-size-guide-units] button[data-unit]').forEach((btn) => {
          const active = btn.dataset.unit === unit;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', String(active));
        });

        const wrap = root.querySelector('[data-unit-display]');
        if (wrap) wrap.dataset.unitDisplay = unit;

        root.querySelectorAll('[data-size-table] [data-cm]').forEach((cell) => {
          cell.textContent = unit === 'inch' ? cell.dataset.inch : cell.dataset.cm;
        });

        root.querySelectorAll('[data-cm-label]').forEach((header) => {
          header.textContent = unit === 'inch' ? header.dataset.inchLabel : header.dataset.cmLabel;
        });
      });
    });

    root.querySelectorAll('[data-measure-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.measureTab;
        if (!id) return;

        root.querySelectorAll('[data-measure-tab]').forEach((t) => {
          t.setAttribute('aria-selected', String(t.dataset.measureTab === id));
        });

        root.querySelectorAll('[data-measure-panel]').forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.measurePanel === id);
        });
      });
    });
  });
}

function scheduleInit() {
  initSizeGuides();
  requestAnimationFrame(initSizeGuides);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleInit);
} else {
  scheduleInit();
}

document.addEventListener('shopify:section:load', scheduleInit);
document.addEventListener('variant:update', () => setTimeout(scheduleInit, 50));
